import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import rawHtml from "../../content/htmlContent"; // Optional static HTML content
import { homePageData, fetchMenuItem } from "../../services/index";
import { checkEmpty } from "../../utils/helper";
import { setSessionUserId, setSsipSession } from "../../utils";

export default function Home() {
  const [htmlContent, setHtmlContent] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const restaurantData = {
    storeSlug: "dixy-chicken-hanley",
    productId: "6223863",
  };

  useEffect(() => {
    getHomePageData(); // Fetch HTML file
    getMenuItem(); // Your menu logic
  }, []);

  const getMenuItem = async () => {
    if (
      !checkEmpty(restaurantData.storeSlug) &&
      !checkEmpty(restaurantData.productId)
    ) {
      const { status, data } = await fetchMenuItem(
        restaurantData.storeSlug,
        restaurantData.productId
      );

      if (status === 200 && data.status === "success") {
        setSsipSession(data?.store?.store_Config?.ssip);
        setSessionUserId(data?.store?.store_Config?.usrId);
        // Optionally store data or call more setup here
      } else {
        console.error("Menu fetch failed");
        setIsLoading(false);
      }
    }
  };

  const getHomePageData = async () => {
    setIsLoading(true);
    try {
      // ✅ Load HTML file (from public folder)
      const response = await fetch("/index.html");
      const html = await response.text();

      // Extract head and body
      const headHtml = html.match(/<head[^>]*>([\s\S]*?)<\/head>/i)?.[1];
      const bodyHtml = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i)?.[1];

      // Inject head styles and scripts
      if (headHtml) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(
          `<head>${headHtml}</head>`,
          "text/html"
        );

        // Inject styles and link tags
        doc.head
          .querySelectorAll("style, link[rel='stylesheet']")
          .forEach((el) => {
            document.head.appendChild(el.cloneNode(true));
          });

        // Inject scripts (⚠️ note: use defer scripts ideally)
        doc.head.querySelectorAll("script").forEach((script) => {
          const newScript = document.createElement("script");
          if (script.src) {
            newScript.src = script.src;
            newScript.async = script.async || true;
            newScript.defer = script.defer || true;
          } else {
            newScript.textContent = script.textContent;
          }
          document.body.appendChild(newScript);
        });
      }
      // Set body content into state
      setHtmlContent(bodyHtml || "");
    } catch (e) {
      console.error("error msg", e);
    } finally {
      setIsLoading(false);
      
    }
  };

  console.log("fsfszsefsdrdrdbgthft", htmlContent);

  return (
    // <div style={{ padding: "2rem", maxWidth: "1000px", margin: "auto" }}>
    //   <h1 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
    //     Home Page – balle balle! 🎉
    //   </h1>

    //   <Link
    //     to="/storemenu"
    //     style={{
    //       display: "inline-block",
    //       marginBottom: "2rem",
    //       padding: "0.75rem 1.5rem",
    //       backgroundColor: "#4F46E5",
    //       color: "#fff",
    //       borderRadius: "0.375rem",
    //       textDecoration: "none",
    //       fontWeight: "bold",
    //     }}
    //   >
    //     Go to Menu
    //   </Link>
    <>
      <div
        // style={{
        //   backgroundColor: "#f9fafb",
        //   padding: "1rem",
        //   border: "1px solid #e5e7eb",
        //   borderRadius: "0.375rem",
        // }}
        dangerouslySetInnerHTML={{ __html: htmlContent }}
      />
    </>
  );
}
